import { render, staticRenderFns } from "./Units.vue?vue&type=template&id=76dd17d1"
import script from "./Units.vue?vue&type=script&lang=js"
export * from "./Units.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports